<template>
    <v-dialog v-model="dialogInterno" max-width="600" persistent>
        <v-card>
            <v-toolbar color="primary" class="text-h6 white--text" elevation="0">
                <v-icon class="mr-2" color="white">drive_file_move</v-icon>
                Sposta {{ elemento ? elemento.nome : "" }}
            </v-toolbar>
            <v-card-text class="mt-3">
                <div class="mb-3">
                    <v-btn text small @click="vaiA(-1)">Home</v-btn>
                    <template v-for="(voce, i) in breadcrumb">
                        <span :key="'sep' + i"> / </span>
                        <v-btn text small :key="i" @click="vaiA(i)">{{ voce.nome }}</v-btn>
                    </template>
                </div>

                <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-3" />

                <v-list dense style="max-height: 300px; overflow-y: auto;">
                    <v-list-item v-for="(c, i) in cartelle" :key="i" @click="entraIn(c)" style="cursor: pointer;">
                        <v-list-item-icon>
                            <v-icon>folder</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>{{ c.nome }}</v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="!loading && cartelle.length === 0">
                        <v-list-item-content class="text-center grey--text">Nessuna sottocartella</v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text @click="chiudi()">Annulla</v-btn>
                <v-btn color="primary" text @click="conferma()" :disabled="loading">Sposta qui</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { get_sole_cartelle, sposta_elemento } from "@/api/api.dati.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        elemento: { type: Object, default: null },
    },

    data: () => ({
        percorsoCorrente: "",
        breadcrumb: [],
        cartelle: [],
        loading: false,
    }),

    computed: {
        dialogInterno: {
            get() {
                return this.dialog;
            },
            set(value) {
                if (!value) this.chiudi();
            },
        },
    },

    watch: {
        dialog(nuovo) {
            if (nuovo) {
                this.percorsoCorrente = "";
                this.breadcrumb = [];
                this.carica();
            }
        },
    },

    methods: {
        async carica() {
            this.loading = true;
            const par = this.percorsoCorrente ? "?path=" + encodeURIComponent(this.percorsoCorrente) : "";
            const res = await get_sole_cartelle(par);
            this.cartelle = res.data;
            this.loading = false;
        },

        entraIn(cartella) {
            this.breadcrumb.push({ nome: cartella.nome, path: cartella.path });
            this.percorsoCorrente = cartella.path;
            this.carica();
        },

        vaiA(indice) {
            if (indice === -1) {
                this.breadcrumb = [];
                this.percorsoCorrente = "";
            } else {
                this.breadcrumb = this.breadcrumb.slice(0, indice + 1);
                this.percorsoCorrente = this.breadcrumb[indice].path;
            }
            this.carica();
        },

        async conferma() {
            if (!this.elemento) return;

            const par = {
                Path: this.elemento.path,
                Destinazione: this.percorsoCorrente,
            };
            const res = await sposta_elemento(par);
            if (res.data === "OK") {
                this.$toast.info("Elemento spostato con successo!");
                this.$emit("spostato");
                this.chiudi();
            } else {
                this.$toast.alert(res.data);
            }
        },

        chiudi() {
            this.$emit("chiudi");
        },
    },
};
</script>
